module.exports = __webpack_public_path__ + "img/metroidvania07.ea756e88.gif";